// 介錯の突き当ての段の版 (?execJabSteps=1028c・1028d・1028e) の、sprites.ts が読む切り替えだけを持つ (2026-10-28)。
//   sprites.ts から読むので、ほかを import しない (exec_jab_steps_1028.ts を直接読むと循環して起動で落ちる)。
//   入れるのは src/exec_jab_steps_1028.ts の setExecJabSteps。
import type { BossAttackTimeline } from './boss_pose_timeline'
import type { Boss } from './types'
let off = false
export function setExecJabTrembleOff(v: boolean): void { off = v }
// 溜めの乱数の微振動を足さないか (1028c の突き当てだけ)。
export function execJabSkipsTremble(attackId: string | undefined): boolean {
  return off && attackId === 'exec_maulJab'
}

// 踏み込みの版 (1028d・配布版の 1028e) は溜めの膨らみ (最大 5%) も足さない (10-28)。
//   膨らみは足元を中心に広げるので溜めの間に足が外へ 4px ずつ滑り、攻撃の頭で 1 に戻る1コマで刃が 9.6px 後ろへ跳ねていた。
let swellOff = false
export function setExecJabSwellOff(v: boolean): void { swellOff = v }
export function execJabSkipsSwell(attackId: string | undefined): boolean {
  return swellOff && attackId === 'exec_maulJab'
}

// 踏み込みの版の連の2拍目以降の並び (10-28)。連の2拍目以降は溜めの頭の立ち姿を溜めの絵へ差し替える決まり
//   (comboNoNeutralImage) があり、入りの段 (立ち姿→戻り2→沈み1) を残すと 溜め→立ち姿→沈み→溜め と行き来する。
//   そこで連の2拍目以降は溜めから入る並びを使う。振り下ろし×2→突き当ての3拍目 (src/exec_jab_fix.ts の上書き) もこちらを使う。
//   並びは src/exec_jab_steps_1028.ts が入れる (循環を避けるため参照だけここに置く)。
let linkTimeline: BossAttackTimeline | null = null
export function setExecJabLinkTimeline(tl: BossAttackTimeline | null): void { linkTimeline = tl }
export function execJabLinkTimeline(boss: Boss): BossAttackTimeline | undefined {
  if (!linkTimeline || boss.id !== 'the-executioner' || boss.currentAttack?.id !== 'exec_maulJab') return undefined
  if (boss.exec?.held === 'cannon' || !boss.currentString || (boss.beatIndex ?? 0) <= 0) return undefined
  return linkTimeline
}
